module.exports = __webpack_public_path__ + "img/selected7-min.adcb11af.png";